import {
  EmployeePerformanceStateTypes,
  EmployeePerformanceActionTypes,
} from "./EmployeePerformance.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EmployeePerformanceStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EmployeePerformanceReducer = (
  state: EmployeePerformanceStateTypes = INITIAL_STATE,
  action: any
): EmployeePerformanceStateTypes => {
  switch (action.type) {
    case EmployeePerformanceActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EmployeePerformanceActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EmployeePerformanceActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EmployeePerformanceActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EmployeePerformanceActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EmployeePerformanceActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case EmployeePerformanceActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EmployeePerformanceActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EmployeePerformanceReducer;
